import { Market } from './marketTypes';

export enum EventStatus {
    ACTIVE,
    DISABLED_BY_PROVIDER,
    DISABLED_BY_SYSTEM
}

export interface Provider {
    id: number;
    name: string;
}

export interface Sport {
    id: number;
    name: string;
}

export interface Competition {
    id: number;
    name: string;
    ruleSet: string;
    /** Template price set override; null = default level applies */
    marginLevel: string | null;
}

export interface Competitor {
    id: number;
    name: string;
}

export interface TeamScore {
    runs: number;
    wickets: number;
    isBatting: boolean;
}

export interface CricketScore {
    sequenceId: number;
    timestamp: number;
    ballReference: string;
    runs: number;
    isWicket: boolean;
    firstTeamScore: TeamScore;
    secondTeamScore: TeamScore;
}

export interface PlayerScore {
    competitorId: number;
    setsWon: number;
    currentSetPoints: number;
}

export interface TtScore {
    sequenceId: number;
    timestamp: number;
    currentSet: number;
    serverCompetitorId?: number;
    pointWinnerCompetitorId?: number;
    players: PlayerScore[];
}

export type TennisGamePhase = 'PREMATCH' | 'SET_IN_PROGRESS' | 'MATCH_END' | 'CANCELLED';

export interface TennisPlayerScore {
    competitorId: number;
    setsWon: number;
    gamesWonCurrentSet: number;
    /** Raw point count in the game in play: 3-3 is deuce, 4-3 advantage; plain counts in a tiebreak. */
    currentGamePoints: number;
}

export interface TennisSetScore {
    set: number;
    winnerCompetitorId?: number;
    scores: { competitorId: number; games: number }[];
}

/** One stored tennis match state; competitor ids are DB ids. `sequence` is 0 on a frame that is not a point. */
export interface TennisScore {
    sequence: number;
    /** Epoch millis. */
    timestamp: number;
    gamePhase: TennisGamePhase;
    currentSet: number;
    /** The game in play within `currentSet`; 0 when none is. */
    currentGame: number;
    serverCompetitorId?: number;
    pointWinnerCompetitorId?: number;
    players: TennisPlayerScore[];
    completedSets: TennisSetScore[];
}

export interface Event {
    id: number;
    provider: Provider;
    providerEventId: string;
    sport: Sport;
    markets?: Market[];
    competition: Competition;
    name: string;
    providerName: string;
    videoUrl: string | null;
    streamId?: string;
    startTime: string;
    firstCompetitor: Competitor;
    secondCompetitor: Competitor;
    status: EventStatus;
    providerEventStatus: EventStatus;
    dataVersion: number;
    sourceTimestamp: number;
    createdAt: string;
    updatedAt: string;
    isCorrupted?: boolean; // Flag to indicate if the event data is incomplete/corrupted
    cricketScores?: CricketScore[];
    ttScores?: TtScore[];
    tennisScores?: TennisScore[];
}
